import "./index.less";
import "../public/index.less";



// WEBPACK FOOTER //
// ./ecology9/wea-collect/style/index.js